import { ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TRAIT_DISPLAY_MAP } from '../traitDisplayMap'
import { TemplateTraitCellContainer } from './TemplateTraitCellContainer'

interface TemplateEditorTableCellProps extends GridRenderCellParams {
  row: { traitId: string; [key: string]: any }
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  canEdit: boolean
  onValueSave: (
    traitId: string,
    year: number,
    filledValues: { value?: unknown; input?: unknown; result?: unknown }
  ) => void
  onValueDelete: (traitId: string, year: number) => void
}

export const TemplateEditorTableCell = ({
  row: { traitId },
  value,
  field: year,
  task,
  canEdit,
  onValueSave,
  onValueDelete,
}: TemplateEditorTableCellProps) => {
  const Display = TRAIT_DISPLAY_MAP[traitId]

  if (!Display) {
    return (
      <Stack>
        <Typography>{JSON.stringify(value)}</Typography>
      </Stack>
    )
  }

  return (
    <TemplateTraitCellContainer
      value={value}
      task={task}
      year={+year}
      traitId={traitId}
      canEdit={canEdit}
      onValueSave={onValueSave}
      onValueDelete={onValueDelete}
    >
      <Display value={value} />
    </TemplateTraitCellContainer>
  )
}
